/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagged1Inputs */

const en_signupsflagged1 = /** @type {(inputs: Signupsflagged1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagged`)
};

const de_signupsflagged1 = /** @type {(inputs: Signupsflagged1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiert`)
};

/**
* | output |
* | --- |
* | "Flagged" |
*
* @param {Signupsflagged1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagged1 = /** @type {((inputs?: Signupsflagged1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagged1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagged1(inputs)
	return de_signupsflagged1(inputs)
});
export { signupsflagged1 as "signupsFlagged" }